import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { OAuthService } from 'angular-oauth2-oidc';
import { LocalStoreManager } from './local-store-manager.service';
import { ConfigurationService } from './configuration.service';
import { DBKeys } from './db-key';
import { LoginResponse } from 'src/app/shared/model/auth/login-response.model';


@Injectable()
export class OidcHelperService {

  private readonly clientId = 'admin';
  private readonly scope = 'openid email phone profile offline_access roles inwardoutward_api';
  get tokenURL() { return this.configurations.baseUrl + '/api/Account/login'; }
  get adminTokenURL() { return this.configurations.baseUrl + '/api/Account/admin'; }
  constructor(
    private http: HttpClient,
    private oauthService: OAuthService,
    private configurations: ConfigurationService,
    private localStorage: LocalStoreManager) {

  }


  loginWithPassword(userName: string, password: string) {
    const header = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const params = new HttpParams()
      .append('username', userName)
      .append('password', password);

    return this.http.post<LoginResponse>(this.tokenURL, params, { headers: header });
  }
  adminLoginWithPassword(userName: string, password: string) {
    const header = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const params = new HttpParams()
      .append('username', userName)
      .append('password', password);

    return this.http.post<LoginResponse>(this.adminTokenURL, params, { headers: header });
  }
  refreshLogin() {
    const header = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const params = new HttpParams()
      .append('refresh_token', this.refreshToken)
      .append('client_id', this.clientId)
      .append('grant_type', 'refresh_token');

    return this.http.post<LoginResponse>(this.tokenURL, params, { headers: header });
  }

  get accessToken(): string {
    return this.localStorage.getData(DBKeys.ACCESS_TOKEN);
  }

  get accessTokenExpiryDate(): Date {
    return this.localStorage.getDataObject<Date>(DBKeys.TOKEN_EXPIRES_IN, true);
  }

  get refreshToken(): string {
    return this.localStorage.getData(DBKeys.REFRESH_TOKEN);
  }

  get isSessionExpired(): boolean {
    if (this.accessTokenExpiryDate == null) {
      return true;
    }
    return this.accessTokenExpiryDate.valueOf() <= new Date().valueOf();
  }
}
